module.exports = __webpack_public_path__ + "img/LogoTerranovaAzul.0ec2b1b4.png";